// Export each validation rule individually
export const required = (value) =>
  (value !== null &&
    value !== undefined &&
    (typeof value === "boolean" ||
      (Array.isArray(value) ? value.length > 0 : !!value))) ||
  "Dit veld is verplicht";

export const email = (value) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) || "Ongeldig e-mailadres";

export const min = (min) => (value) => {
  if (Array.isArray(value)) {
    return (
      value.length >= min ||
      `Selecteer minimaal ${min} item${min > 1 ? "s" : ""}`
    );
  }

  value = value.toString().trim();

  return value.length >= min || `Minimaal ${min} karakters`;
};

export const max = (max) => (value) => {
  if (value === null || value === undefined) {
    return true;
  }

  if (Array.isArray(value)) {
    return (
      value.length <= max ||
      `Selecteer maximaal ${max} item${max > 1 ? "s" : ""}`
    );
  }

  return value.length <= max || `Maximaal ${max} karakters`;
};

// Utility function to check for null or undefined
export const isNullOrUndefined = (value) =>
  value === null || value === undefined;

// Utility function to check if value is a number
export const isNumber = (value) =>
  typeof value === "number" &&
  !isNaN(value) &&
  value !== Infinity &&
  value !== -Infinity;

export const maxNumber = (max) => (value) => {
  value = parseFloat(value, 10);

  if (isNullOrUndefined(value)) {
    return true;
  }

  if (!isNumber(value)) {
    return "Ongeldige waarde, moet een getal zijn";
  }

  return value <= max || `Maximaal ${max}`;
};

export const minNumber = (min) => (value) => {
  value = parseFloat(value, 10);

  if (isNullOrUndefined(value)) {
    return true;
  }

  if (!isNumber(value)) {
    return "Ongeldige waarde, moet een getal zijn";
  }

  return value >= min || `Minimaal ${min}`;
};

export const url = (value) =>
  /^(https?:\/\/)/.test(value) ||
  "Ongeldige URL, moet beginnen met http:// of https://";

// Default export for backward compatibility
export default {
  required,
  email,
  min,
  max,
  url,
};
